// React
import { useContext } from "react"

// Component
import { Select } from "components"

// Contexts
import { PoContext } from "../contexts"

// Form
import { useFormContext } from "react-hook-form"

// Types
import type { SelectOptionType } from "types"
import type { FormType } from "../utils"

export function Vendor(): JSX.Element {
  // Hooks
  const data = useContext(PoContext)

  // Form
  const { getValues } = useFormContext<FormType>()

  // Vars
  const datapo = data.datapo
  const options: SelectOptionType[] = [
    {
      label: datapo.vendor_name,
      value: datapo.vendor_id
    }
  ]

  return (
    <Select
      isDisabled
      label="PAY TO"
      options={options}
      value={options.find(item => item.value === getValues("vendor_id"))}
    />
  )
}